import type { IDateFilterParams } from "ag-grid-community";

export const filterParams: IDateFilterParams = {
  comparator: (filterLocalDateAtMidnight: Date, cellValue: string) => {
    if (cellValue == null) return -1;
    // This removes the time for comparison
    const cellDate = new Date(new Date(cellValue).toDateString());
    if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
      return 0;
    }

    if (cellDate < filterLocalDateAtMidnight) {
      return -1;
    }

    if (cellDate > filterLocalDateAtMidnight) {
      return 1;
    }
    return 0;
  },
};

export enum PasswordStatusOptions {
  CONFIRMED = "CONFIRMED",
  TEMP_PASSWORD = "TEMP PASSWORD",
  SSO_ONLY = "SSO ONLY",
}
